import { BusinessUnitAddressItemComponentBase } from './business-unit-address-item.component.base';
import { Component, ElementRef, Injector } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { CrudEditorParentService, CrudEditorSelfService, postCodeValidator, requiredValidator, UserStorage } from '@scisys-uim/uim-common';
import { BusinessUnitAddressService, BusinessUnitService, RefCodeStorage } from 'assets-service';


@Component({
  selector: 'app-business-unit-address-item',
  templateUrl: './business-unit-address-item.component.html',
  styleUrls: ['./business-unit-address-item.component.scss'],
  providers: [CrudEditorParentService],
  viewProviders: [CrudEditorSelfService]
})
export class BusinessUnitAddressItemComponent extends BusinessUnitAddressItemComponentBase {

  constructor(protected businessUnitAddressService: BusinessUnitAddressService,
    protected businessUnitService: BusinessUnitService,
    protected refCodeStorage: RefCodeStorage,
    protected fb: FormBuilder,
    protected elementRef: ElementRef,
    protected router: Router,
    protected route: ActivatedRoute,
    protected userStorage: UserStorage,
    protected dialog: MatDialog,
    protected injector: Injector,
    protected snackbar: MatSnackBar) {
    super(businessUnitAddressService, businessUnitService, refCodeStorage, fb, elementRef, router, route, userStorage, dialog, injector, snackbar);
  }

  createForm(): FormGroup {
    const form = super.createForm();
    form.controls.postcode.setValidators([requiredValidator, postCodeValidator()]);
    return form;
  }

  protected onInitAsyncComplete() {
    super.onInitAsyncComplete();
    this.businessUnitLoadSelectionList();
    this.addrTypeLoadSelectionList();
  }
    
  itemSet() {
    super.itemSet();
  }
  
  setDefaultDisabledFields() {
    super.setDefaultDisabledFields();
    if (!this.form) {
      return;
    }
    this.businessUnitAddressId?.disable();
    this.createdBy?.disable();
    this.createdDate?.disable();
    this.updatedBy?.disable();
    this.updatedDate?.disable();
  }
}





